"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidatedEligibilityDataSurveyScheduleToJSON = exports.ValidatedEligibilityDataSurveyScheduleFromJSONTyped = exports.ValidatedEligibilityDataSurveyScheduleFromJSON = exports.instanceOfValidatedEligibilityDataSurveySchedule = void 0;
/**
 * Check if a given object implements the ValidatedEligibilityDataSurveySchedule interface.
 */
function instanceOfValidatedEligibilityDataSurveySchedule(value) {
    var isInstance = true;
    isInstance = isInstance && "startDate" in value;
    isInstance = isInstance && "endDate" in value;
    return isInstance;
}
exports.instanceOfValidatedEligibilityDataSurveySchedule = instanceOfValidatedEligibilityDataSurveySchedule;
function ValidatedEligibilityDataSurveyScheduleFromJSON(json) {
    return ValidatedEligibilityDataSurveyScheduleFromJSONTyped(json, false);
}
exports.ValidatedEligibilityDataSurveyScheduleFromJSON = ValidatedEligibilityDataSurveyScheduleFromJSON;
function ValidatedEligibilityDataSurveyScheduleFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'startDate': (new Date(json['start_date'])),
        'endDate': (new Date(json['end_date'])),
    };
}
exports.ValidatedEligibilityDataSurveyScheduleFromJSONTyped = ValidatedEligibilityDataSurveyScheduleFromJSONTyped;
function ValidatedEligibilityDataSurveyScheduleToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'start_date': (value.startDate.toISOString()),
        'end_date': (value.endDate.toISOString()),
    };
}
exports.ValidatedEligibilityDataSurveyScheduleToJSON = ValidatedEligibilityDataSurveyScheduleToJSON;
